import { FC } from 'react';

import { useGender } from '../../../../hooks/use-gender';
import { useTranslations } from '../../../../hooks/use-translations';
import { isIn } from '../../../../utils/array';

import { SelectForm, SelectFormProps } from './SelectForm';

type GenderSelectFormProps = Omit<SelectFormProps<string>, 'options'> & {
  withEmpty?: boolean;
};

export const GenderSelectForm: FC<GenderSelectFormProps> = (props) => {
  const { placeholder, withEmpty, ...selectProps } = props;

  const { loading, data } = useGender();

  const tMisc = useTranslations('misc');
  const t = useTranslations('dictionaries.gender');

  return (
    <SelectForm
      {...selectProps}
      placeholder={loading ? tMisc('loading') : placeholder}
      options={
        data
          ? [
              ...(withEmpty ? ([{ value: '', name: t('all') }] as const) : []),
              ...data.gender.map(({ id }) => ({
                value: id,
                name: isIn(id, ['male', 'female']) ? t(id) : id,
              })),
            ]
          : []
      }
      disabled={loading}
    />
  );
};
